// Mutation constant
export const PURGE_AUTH = "logOut";
export const SET_ACCESS_TOKEN = "setAccessToken";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoading";
export const SET_STATUS = "setStatus";
export const CLEAR_DATA = "clearData";